import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ADESAO.ITENS.BUSCAR_PAGINADO](context, { paginacao, idAdesao }) {
		const { data } = await api.itensAdesao.buscarItensQueJaEstaNaAdesao(paginacao, idAdesao)
		return data
	},
}
